import styled from 'styled-components';

export const BookedWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`
export const BookedInfo = styled.p`
  font-size: 2rem;
  color:#25B75F;
  text-transform: uppercase;
`